<template>
	<v-dialog
		v-model="isOpen"
		width="auto"
		class="global-modal"
		:class="[{ 'global-modal--no-sticky': !noSticky }, { 'global-modal--index': zIndex }]"
		:scrollable="!!scrollable"
		:persistent="persistent"
		:fullscreen="isMobile && fullscreen"
		@click:outside="closeModalOutside">
		<v-card v-if="scrollable">
			<v-card-text :style="`height: ${scrollable}px`">
				<ButtonCustom v-if="backBtn" class="global-modal__back-btn" iconBefore="arrow-previous" @click="emit('goBack')">{{
					'Go back'
				}}</ButtonCustom>
				<ButtonIcon class="global-modal__close" @click="closeModal">
					<GlobalIcon name="close-bold" :height="9"></GlobalIcon>
				</ButtonIcon>
				<div
					class="global-modal__container"
					:class="{ 'global-modal__container--no-padding': noPadding, 'global-modal__container--fullscreen': isMobile && fullscreen }">
					<slot />
				</div>
			</v-card-text>
		</v-card>

		<div
			v-else
			class="global-modal__container"
			:class="{ 'global-modal__container--no-padding': noPadding, 'global-modal__container--fullscreen': isMobile && fullscreen }">
			<ButtonCustom v-if="backBtn" class="global-modal__back-btn" iconBefore="arrow-previous" @click="emit('goBack')">
				<span v-if="!isMobile_sm"> {{ $t('common.back') }} </span>
			</ButtonCustom>
			<ButtonIcon class="global-modal__close" @click="closeModal">
				<GlobalIcon name="close-bold" :height="9"></GlobalIcon>
			</ButtonIcon>
			<slot />
		</div>
	</v-dialog>
</template>

<script setup lang="ts">
const isOpen = defineModel<boolean>()
const { isMobile, isMobile_sm } = useWindowWidth()

const props = defineProps<{
	noPadding?: boolean
	scrollable?: number
	noSticky?: boolean
	backBtn?: boolean
	radius?: number
	zIndex?: boolean
	persistent?: boolean
	fullscreen?: boolean
}>()

const emit = defineEmits<{
	(e: 'close'): void
	(e: 'goBack'): void
}>()

const closeWithEsc = (e: any) => {
	if (e.keyCode === 27) {
		closeModalOutside()
	}
}

onMounted(() => {
	document.addEventListener('keydown', closeWithEsc, true)
})

const closeModalOutside = () => {
	if (props.persistent) return
	isOpen.value = false
	emit('close')
}

const closeModal = () => {
	isOpen.value = false
	emit('close')
}

onUnmounted(() => {
	document.removeEventListener('keydown', closeWithEsc, true)
})
</script>

<style lang="scss">
@import './Modal';
</style>
